import { showErrToast } from "./components/Toasts";
import { ChannelType } from "./models/ChannelType";
import type ConnectableObject from "./models/ConnectableObject";
import type Connection from "./models/Connection";
import type { ConnectionType } from "./models/Connection";
import type Page from "./models/Page";
import { itx } from "./translationItx/itx";
import { createModelConnection, persistConnectionEndpoint } from "./models/connectionCreation";

export default class CurrentDrawingConnection {
  connection: Connection | null = null;
  channelType = ChannelType.Unknown;
  page: Page | null = null;
  currentTargetIsChannel: boolean = false;
  currentTargetIsActor: boolean = false;
  currentTargetIsScene: boolean = false;

  clear() {
    this.connection = null;
    this.page = null;
    this.channelType = ChannelType.Unknown;
    this.currentTargetIsChannel = false;
    this.currentTargetIsActor = false;
    this.currentTargetIsScene = false;
  }

  makePersistent(obj: ConnectableObject | undefined) {
    persistConnectionEndpoint(obj, state);
  }

  connect(target: ConnectableObject | undefined, connectionType: ConnectionType) {
    const draft = this.connection;
    const page = this.page;
    try {
      if (target && draft?.fromDevice) {
        const result = createModelConnection(draft.fromDevice, target, state, draft.type);
        if (!result.connection) {
          showErrToast(result.msg || itx("Connection.connectionForbidden", "Verbindung verboten"));
        } else {
          page?.updateConnections();
        }
      }
    } finally {
      if (draft) {
        draft.fromDevice = undefined;
        draft.toDevice = undefined;
        draft.delete();
      }
      this.clear();
    }
  }
}
